import { API_SERVICES } from '@/services/constants';
import { APICreate } from './api';
export { AxiosError } from 'axios';

export const API = new APICreate();

API.config({
  [API_SERVICES.BASE_API]: {
    base_url: import.meta.env.VITE_API_BASE_URL,
    withCredentials: true,
  },
});
